import {renderValue} from "../renderValues";
import React from "react";
import {Grid, Typography, ArrowUpward, ArrowDownward} from "@leap4/frontend";


interface ISingleMetricProps{
    metricValue:number,
    metricEnum:string
    metricChange?:string
}
export const SingleMetric = ({metricValue, metricEnum,metricChange}: ISingleMetricProps) => {
    const color = parseFloat(metricChange)<0?'red':'green'
    const metricSignByChange = parseFloat(metricChange)<0? <ArrowDownward style={{fontSize:"12px"}}/>:<ArrowUpward style={{fontSize:"12px"}}/>;
    if(!metricEnum || !metricValue) return <></>
    return (
    <>
        <Typography fontFamily={"Quicksand"} fontWeight={700} style={{fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap'}}>
            {metricEnum.toUpperCase()}
        </Typography>
        {metricChange && <b style={{color,fontSize:'12px'}}>{metricSignByChange}{metricChange}</b>}
        {renderValue(metricValue || 0, metricEnum)}
    </>
)}

export const SingleMetricForCard = ({metricValue, metricEnum,metricChange}: ISingleMetricProps) => {
    const color = parseFloat(metricChange)<0?'red':'green'
    const metricSignByChange = parseFloat(metricChange)<0? <ArrowDownward style={{fontSize:"12px"}}/>:<ArrowUpward style={{fontSize:"12px"}}/>;
    if(!metricEnum || !metricValue) return <></>
    return (
        <>
            <Grid container gap={2} alignItems={'center'} justifyContent={'flex-end'} sx={{ width: '100%', paddingRight: '16px' }}>
            <Grid item sx={{ minWidth: '80px', textAlign: 'right' }}>
                {metricChange && <b style={{color,fontSize:'12px'}}>{metricSignByChange}{metricChange}</b>}
            </Grid>
            <Grid item sx={{ minWidth: '140px', textAlign: 'right' }}>
                {renderValue(metricValue || 0, metricEnum)}
            </Grid>
            </Grid>
        </>
    )}